export const IT = {
  // Autenticazione
  login: "Accedi",
  dont_have_any_account: "Non hai un account?",
  do_you_have_any_account: "Hai un account?",
  privacy_policy_text: "Cliccando sul pulsante continua o accedendo tramite terze parti accetti tutte le condizioni di Upload The Truth",
  privacy_policy: "Politica sulla riservatezza",
  and_others: "e altri.",
  register_now: "Registrati ora",
  forgot_password: "Password dimenticata?",
  is_it_your_account: "È il tuo account?",
  contact_with: "Contatta il",
  support_team: "team di supporto",
  send_otp: "Invia OTP",
  an_otp_will_be_sent_to_your_phone: "Un OTP verrà inviato al tuo telefono / email",
  email_or_phone: "Telefono / Email",
  enter_email_or_phone: "Inserisci un'email o un numero di telefono.",
  send: "Invia",
  write_appropriate_note: "Scrivi una nota adeguata qui",
  select_date: "Seleziona Data",
  last_activity_date: "Ultima data di attività (opzionale)",
  recent_password: "Password recente (opzionale)",
  fb_username: "Nome utente Facebook",
  phone: "Telefono",
  email_placeholder: "Inserisci indirizzo email",
  contact_email: "Email di contatto",
  google_account: "Account Google",
  account_created_with: "Account creato con",
  continue_with: "Continua con",
  google: "Google",
  facebook: "Facebook",
  whatsapp: "WhatsApp",
  registration: "Registrazione",
  register: "Registrati",
  full_name: "Nome completo",
  profile_picture: "Immagine del profilo",
  failed: "Errore!",
  success: "Perfetto",
  an_6_digit_code: "Un codice a 6 cifre",
  was_sent: "è stato inviato",
  didnt_receive_code: "Non hai ricevuto il codice?",
  resend: "Reinvia",
  verify: "Verifica",
  verify_your_email: "Verifica la tua email",
  verify_your_mobile: "Verifica il tuo numero di telefono",
  please_try_again_after: "Riprova dopo",
  otp_will_be_expired_in: "L'OTP scadrà in",
  is_change: "Modificare?",
  go_back: "Torna indietro",
  invalid_otp_code: "OTP non valido!",
  confirm_your_mobile: "Conferma il tuo numero di telefono",
  choose_how_you_want_to_confirm: "Scegli come confermare che",
  belongs_to_you: "ti appartiene.",
  send_code_via_sms: "Invia codice via SMS",
  send_code_via_whatsapp: "Invia codice via WhatsApp",
  old_password: "Vecchia password",
  new_password: "Nuova password",
  confirm_password: "Conferma password",

  // Vuoto
  no_data: "Nessun dato trovato",
  there_is_no_data: "Non ci sono dati",
  no_data_available: "Nessun dato disponibile",
  there_are_no_records_to_display: "Non ci sono record da mostrare",

  // Testo Comune
  welcome: "Benvenuto",
  welcome_back: "Bentornato",
  login_your_account: "Accedi al tuo account",
  notification: "Notifica",
  hello: "Ehi!",
  happy_to_see_you_again: "Felice di rivederti",
  overview: "Panoramica",
  most_recent: "Più recenti",
  view_all: "Vedi tutto",
  change_status: "Cambia stato",
  camera: "Fotocamera",
  gallery: "Galleria",
  image: "IMMAGINE",
  language: "Lingua",
  session_timeout: "Sessione scaduta",
  file: "File",
  go: "Vai",
  select_language: "Seleziona lingua",
  enter: "Inserisci",

  // Etichette
  title: "Titolo",
  new: "Nuovo",
  description: "Descrizione",
  details: "Dettagli",
  optional: "Opzionale",
  start_date: "Data di inizio",
  expire_start_date: "Data di inizio scadenza",
  expire_end_date: "Data di fine scadenza",
  end_date: "Data di fine",
  active: "Attivo",
  none: "Nessuno",
  n_a: "N/A",
  deactivate: "Disattiva",
  write_here: "Scrivi qui",
  select: "Seleziona",
  search_option: "Opzione di ricerca",
  first_name: "Nome",
  last_name: "Cognome",
  username: "Nome utente",
  email: "Email",
  mobile: "Cellulare",
  new_password: "Nuova password",
  confirm_new_password: "Conferma nuova password",
  select_one: "Seleziona uno",
  action: "Azione",
  status: "Stato",
  type: "Tipo",
  total: "Totale",
  birth_date: "Data di nascita",
  gender: "Genere",
  phone_number: "Numero di telefono",
  postal_code: "Codice postale",
  address: "Indirizzo",
  name: "Nome",
  document: "Documento",
  note: "Nota",
  password: "Password",
  date: "Data",
  city: "Città",
  cap: "CAP",
  not_define: "Non definito",
  logo: "Logo",
  advance: "Avanzato",
  otp: "OTP",
  tags: "Tag",
  report: "Segnala",
  anonymous: "Anonimo",
  see_more: "...Vedi di più",
  optimizing: "Ottimizzando...",
  you_r_searching_for: "Stai cercando...",

  // Avvisi
  oops: "Ops",
  are_you_sure: "Sei sicuro?",
  are_you_sure_to_logout: "Sei sicuro di voler uscire?",
  you_wont_be_able_to_revert_this: "Non potrai annullare questa azione!",
  are_you_sure_you_want_to_delete: "Sei sicuro di voler eliminare?",
  this_action_will_permanently_delete_the_item_and_cannot_be_undone: "Questa azione eliminerà permanentemente l'elemento e non potrà essere annullata.",
  yes_delete_it: "Sì, eliminalo!",
  yes_confirm_it: "Sì, confermalo!",
  page_not_found: "Ops! Pagina non trovata",
  back_to_login: "Torna al login",
 
  login_success: "Accesso riuscito",
  login_failed: "Accesso fallito",
  invalid_username_or_password: "Nome utente o password non validi",

  successfully: "Perfetto",
  successfully_done: "Operazione completata con successo",
  submitted: "Creato con successo",
  created_successfully: "Inviato!",
  updated_successfully: "Aggiornato con successo",
  deleted_successfully: "Eliminato con successo",
  status_changed_successfully: "Stato modificato con successo",

  permission_denied: "Permesso negato",
  permission_denied_message: "È necessario il permesso di archiviazione per scaricare il file.",
  please_check_your_permission_and_try_again: "Se non ci concedi il permesso, non possiamo procedere",
  file_saved_to: "File salvato in",
  duplicate_not_allowed: "Duplicati non consentiti",
  you_missed_some_required_fields: "Hai dimenticato alcuni campi obbligatori",
  please_check_all_required_fields: "Si prega di controllare tutti i campi obbligatori",
  no_internet_connection: "Nessuna connessione a Internet",
  please_check_your_internet_connection_and_try_again: "Controlla la tua connessione a Internet e riprova.",
  something_went_wrong_try_again: "Qualcosa è andato storto, riprova",
  something_went_wrong: "Qualcosa è andato storto",
  we_are_working_on_it: "Ci stiamo lavorando. Il tuo percorso di ricompensa è ancora in corso!",
  please_try_again_later: "Riprova più tardi.",
  please_try_again: "Riprova.",
  your_item_has_been_deleted: "Il tuo elemento è stato eliminato",
  please_enter_empty_field: "Per favore, compila il campo vuoto!",
  
  update_location: "Aggiorna la tua posizione",
  update_location_description: "Raccogliamo la posizione del paese dell'utente per mostrare contenuti migliori.",
  thank_you: "Grazie!",
  
  // SUCCESS_MESSAGES
  forgot_password_support: "Abbiamo inviato un'email all'indirizzo fornito con le istruzioni per reimpostare la password.",
  user_contact: "Ti contatteremo via email a breve.",
  registration_success: "Registrazione avvenuta con successo! Benvenuto su Upload The Truth.",
  password_change: "La tua password è stata aggiornata con successo. Ora puoi accedere con la nuova password.",
  comment_added: "Commento aggiunto con successo!",
  report_submitted: "Grazie! La tua segnalazione è stata inviata.",
  post_saved_success: "Post salvato con successo nella tua lista Guarda più tardi.",
  post_removed_success: "Post rimosso con successo dalla tua lista Guarda più tardi.",
  post_remove_to_watch: "Post rimosso con successo dalla tua lista Guarda più tardi.",
  post_remove_from_history: "Post rimosso con successo dalla tua cronologia.",

  // ERROR_MESSAGES
  common_error: "Non siamo riusciti a completare la tua richiesta. Controlla la connessione e riprova.",
  validation_error: "Errore di convalida. Controlla i dati inseriti e riprova.",
  registration_error: "Si è verificato un problema durante la registrazione. Riprova più tardi.",
  registered_but_not_success: "Grazie per esserti registrato! I tuoi dati sono in fase di verifica per motivi di sicurezza. Riprova tra qualche minuto.",
  login_validation: "Credenziali non valide. Verifica i tuoi dati di accesso e riprova.",
  forgot_password_invalid_username: "Inserisci un indirizzo email o un numero di telefono valido con il corretto prefisso internazionale.",
  otp_invalid_phone_whatsapp: "Il numero di telefono fornito non è valido. Riprova.",
  otp_already_sent: "Un OTP è già stato inviato. Riprova dopo la scadenza dell'OTP attuale.",
  video_compress: "Stiamo riscontrando problemi tecnici. Riprova più tardi.",
  invalid_old_password: "La vecchia password inserita non è corretta. Riprova.", // durante il cambio password
  expired_otp: "Il tuo OTP è scaduto. Richiedine uno nuovo e riprova.",
  invalid_otp: "Verifica il codice e riprova.",
  otp_required: "Inserisci l'OTP per procedere.",
  video_thumbnail_problem: "Si è verificato un problema durante la creazione della miniatura. Riprova.",
  video_file_not_found: "Il file video non è stato trovato. Caricalo di nuovo.", // durante il caricamento
  video_upload: "Si è verificato un problema con il caricamento del video. Potrebbe essere danneggiato o ci sono stati problemi di rete. Riprova.",
  notification_error: "Nessuna nuova notifica al momento. Rimani informato, partecipa e continua a caricare la verità!",
  search_error: "Nessun contenuto corrisponde alla tua ricerca. Prova a modificare le parole chiave o esplora altri argomenti!",
  home_page_error: "Al momento non riusciamo a caricare il contenuto. Controlla la connessione, aggiorna la pagina o riprova più tardi!",
  profile_view: "Non siamo riusciti a caricare i dettagli del tuo profilo. Controlla la connessione e riprova.",
  profile_update: "Si è verificato un errore durante il salvataggio delle modifiche. Assicurati che tutti i campi siano corretti e riprova.",
  post_manage_data: "Non siamo riusciti a caricare i tuoi video. Controlla la connessione e riprova.",
  post_update: "Impossibile salvare le modifiche al tuo video. Controlla la connessione e riprova.",
  google_reg: "Non siamo riusciti a recuperare le tue informazioni da Google. Assicurati di essere connesso e riprova.",
  facebook_reg: "Non siamo riusciti a recuperare le tue informazioni da Facebook. Assicurati di essere connesso e riprova.",
  storage_low: "Lo spazio di archiviazione del dispositivo è insufficiente. L’operazione non è stata completata correttamente. Libera spazio e riprova.",

  // Validazione del modulo
  required: "Questo campo è obbligatorio.",
  min_characters: "L'input deve contenere almeno {min} caratteri.",
  max_characters: "L'input non deve superare {max} caratteri.",
  //
  name_required: "Inserisci il nome.",
  name_250_characters: "Il nome può contenere al massimo 250 caratteri.",
  //
  full_name_required: "Inserisci il tuo nome completo.",
  //
  phone_required: "Inserisci il numero di telefono.",
  phone_15_characters: "Il numero di telefono può contenere al massimo 15 caratteri.",
  phone_invalid: "Inserisci un numero di telefono valido.",
  //
  email_required: "Inserisci l'email.",
  contact_email_required: "Inserisci un'email di contatto.",
  email_250_characters: "L'email può contenere al massimo 250 caratteri.",
  email_invalid: "Inserisci un'email valida.",
  //
  address_required: "Inserisci l'indirizzo.",
  address_500_characters: "L'indirizzo può contenere al massimo 500 caratteri.",
  //
  old_password_required: "Inserisci la vecchia password.",
  //
  password_required: "Inserisci la password.",
  password_6_characters: "La password deve contenere almeno 6 caratteri.",
  //
  confirm_password_required: "Reinserisci la password.",
  password_not_match: "Le password non coincidono.",
  //
  facebook_required: "Inserisci il nome utente di Facebook.",
  please_select_item: "Seleziona un elemento.",

  // Button
  done: "Fatto",
  back: "Indietro",
  add: "Aggiungi",
  add_new: "Aggiungi nuovo",
  next: "Avanti",
  save_and_next: "Salva e Avanti",
  edit: "Modifica",
  share: "Condividi",
  update: "Aggiorna",
  submit: "Invia",
  create: "Crea",
  remove: "Rimuovi",
  delete: "Elimina",
  print: "Stampa",
  cancel: "Annulla",
  download: "Scarica",
  search: "Cerca",
  clear: "Cancella",
  yes: "Si",
  no: "No",
  upload: "Carica",
  upload_file: "Carica file",
  all: "Tutti",
  see_more: "Vedi di più",
  or: "O",
  ok: "Ok",
  to: "A",
  close: "Chiudi",
  logout: "Esci",
  profile: "Profilo",
  preview: "Anteprima",
  confirm: "Conferma",
  continue: "Continua",
  skip: "Salta",
  change: "Cambia",

  // Modulo di caricamento
  scanning: "Scansione in corso...",
  searching_keywords: "Ricerca parole chiave",
  write_a_keyword_here: "Scrivi una parola chiave qui",
  content_language: "Lingue del contenuto",
  description_write: "Descrivi cosa sta accadendo",
  please_write_a_title: "Inserisci un titolo",
  please_write_a_text: "Per favore scrivi un testo",
  type_your_text_here: "Scrivi il tuo testo qui...",
  sub_category: "Sottocategoria",
  sub_categories: "Sottocategorie",
  you_can_choose_maximum_3: "(Puoi scegliere fino a 3)",
  please_select_a_category: "Seleziona una categoria",
  select_category: "Seleziona categoria",
  category: "Categoria",
  categories: "Categorie",
  post_anonymously: "Pubblica in modo anonimo",
  hide_your_identity: "Nascondi la tua identità",
  create_post: "Crea post",
  upload_audio: "Carica audio",
  upload_video: "Carica video",
  display_picture_required: "Immagine di anteprima richiesta",
  content_location: "Posizione del contenuto",
  you_can_add_multiple_keywords: "Puoi aggiungere più parole chiave",
  you_can_choose_multiple_languages: "Puoi scegliere più lingue",
  maximum_3: "Massimo 3",

  // Mesi
  Jan: "Gen",
  Feb: "Feb",
  Mar: "Mar",
  Apr: "Apr",
  May: "Mag",
  Jun: "Giu",
  Jul: "Lug",
  Aug: "Ago",
  Sep: "Set",
  Oct: "Ott",
  Nov: "Nov",
  Dec: "Dic",

  // Tempo
  minute: "minuto",
  minutes: "minuti",
  hour: "ora",
  hours: "ore",
  day: "giorno",
  days: "giorni",
  week: "settimana",
  weeks: "settimane",
  month: "mese",
  months: "mesi",
  year: "anno",
  years: "anni",
  ago: "fa",
  today: "Oggi",
  yesterday: "Ieri",
  days_ago: "giorni fa",

  // Commenti
  comment: "Commento",
  comments: "Commenti",
  community_guidelines: "Linee guida della community",
  add_comment_here: "Aggiungi un commento qui",
  add_your_comment: "Aggiungi il tuo commento",
  keep_comment_respectful: "Ricorda di mantenere il commento rispettoso e di seguire le nostre",

  // Barra laterale
  trending: "Tendenze",
  confession: "Confessione",
  audio: "Audio",
  audios: "Audio",
  record_audio: "Registra audio",
  add_details: "Aggiungi dettagli",
  edit_details: "Modifica dettagli",
  post_details: "Dettagli del post",
  coins_history: "Cronologia UTT Coins",
  help_feedback: "Aiuto & Feedback",
  basic_info: "Informazioni di base",
  already_registered: "Già registrato",
  change_password: "Cambia password",
  reset_password: "Reimposta password",
  forgot_password: "Password dimenticata?",
  audio_file: "File audio",
  video: "Video",
  videos: "Video",
  image: "Immagine",
  images: "Immagini",
  power_play: "Riproduzione potente",
  text: "Testo",
  texts: "Testi",
  play: "Riproduci",
  utt_coins: "UTT Coins",
  your_reactions: "Le tue reazioni",
  your_comments: "I tuoi commenti",
  my_uploads: "I miei caricamenti",
  my_supporting: "I miei supporti",
  invite_friends: "Invita amici",
  help_center: "Centro assistenza / FAQ",
  guidelines_rules: "Linee guida & Regole",
  terms_privacy: "Termini di utilizzo . Privacy & Riservatezza",

  // Versione
  version: "Versione",
  new_version_available: "È disponibile una nuova versione!",
  please_update: "Aggiorna ora.",
  update_now: "Aggiorna ora",
  later: "Più tardi",

  // Tab inferiore
  home: "Casa",
  pp: "PP",
  save: "Salva",
  history: "Cronologia",
  upload_your_content: "Carica il tuo contenuto",
  save_to_watch_later: "Salva per guardare più tardi",
  remove_from_saved: "Rimuovi dai salvati",
  remove_from_history: "Rimuovi dalla cronologia",

  // 
  app: 'App', // nome del modulo
  truth: 'Verità',
  fake: 'Falso',
  view: 'Visualizza',
  views: 'Visualizzazioni',
  hide: 'Nascondi',
  upload_in_progress: "Caricamento in corso...",
  upload_successful: "Caricamento riuscito",
  profile_info: 'Informazioni sul profilo', // nome del modulo
  manage_activity: 'Gestisci la tua attività',
  display_channel_name: 'Visualizza il nome del canale',
  max_50_words: 'Massimo 50 parole',
  bio_about_yourself: 'Bio / Su di te',
  max_100_words: 'Massimo 100 parole',
  support: 'Supporto',
  supporter: 'Sostenitore',
  supporters: 'Sostenitori',
  supporting: 'Supportando',
  supportings: 'Supporti',
  total_supporters: 'Totale Sostenitori',
  total_supportings: 'Totale Supporti',
  personal_info: "Informazioni personali",
  home_country: "Paese di origine",
  home_location: "Posizione di origine",
  current: "Corrente",
  delivery: "Consegna",
  same_as_home_address: "Uguale all'indirizzo di casa",
  same_as_current_address: "Uguale all'indirizzo attuale",
  other_address: "Altro indirizzo",
  delivery_address_note: "Se vinci un concorso su Upload the Truth, il premio verrà inviato a questo indirizzo.",
  select_country: "Seleziona il Paese",
  current_country: "Paese attuale",
  current_location: "Posizione attuale",
  location: "Posizione",
  country: "Paese",
  please_select_a_country: "Seleziona un paese",
  please_select_home_country_first: "Seleziona prima il paese di origine",
  please_select_current_country_first: "Seleziona prima il paese attuale",
  please_select_delivery_country_first: "Seleziona prima il paese di consegna",
  we_collect_user_country_location: "Raccogliamo la posizione del paese dell'utente per mostrare contenuti migliori.",
  update_your_location: "Aggiorna la tua posizione",
  please_select_language: "Seleziona la tua lingua",
  privacy_and_security: "Privacy & Sicurezza",
  type_otp: "Inserisci il tuo OTP di 6 cifre",
  terms_and_conditions: "Termini & Condizioni",

  setting_and_others: "Impostazioni & Altri", // nome del modulo
  app_language: "Lingua dell'app",
  languages: "Lingue",
  deactivate_account: "Disattiva/Elimina account",
  contact_us: "Contattaci",
  please_write_number:  "Scrivi un numero",
  please_write_email:  "Scrivi una email",
  please_enter_a_contact_email: "Inserisci un'email di contatto",
  please_write_valid_email: "Scrivi una email valida",
  please_write_subject: "Scrivi un oggetto",
  please_write_message: "Scrivi un messaggio",
  thank_you: "Grazie!",
  message: "Messaggio",
  write_appropriate_message_here: "Scrivi qui il messaggio appropriato",
  subject: "Oggetto",
  reason: "Motivo",
  select_reason: "Seleziona il motivo",
  please_select_reason: "Seleziona un motivo",
  write_the_reason: "Scrivi il motivo",
  please_write_the_reason: "Scrivi il motivo",
  delete_request: "INVIA RICHIESTA DI ELIMINAZIONE",
  deactivate_message: `Ci vorranno almeno 45 giorni per eliminare completamente il tuo account. 
    Tuttavia, durante questi 45 giorni, se accedi di nuovo, la richiesta di eliminazione verrà annullata. Nel frattempo, però, nessuno ti troverà su questa applicazione, eccetto i dati nella cache.`,
  support_message: "Ti contatteremo via email per guidarti nel processo di reimpostazione della password",

  why_upload_the_truth: "Perché caricare la verit�?",
  more_videos: "Altri video",
  no_internet: "Nessuna connessione internet",
  confirmation: "Conferma",
  video_cancel_confirmation_message: "Il video registrato/selezionato verràscartato dall'app. Vuoi continuare?",
  trimmingText: "Elaborazione del tuo video",
  video_selection_error: "Oh no! Il video che hai selezionato non esiste o non è riuscito a caricare, ci scusiamo",
  restart: "Ricomincia",

  //coins
  total_coins: "Totale UTT Coins",
  history: "Storia",
  coins_history: "Storico degli UTT Coins",
  coins: "UTT Coins",
  referral_and_gift: "Referral & Regalo",
  monetization: "Monetizzazione",
  you_are_not_yet_eligible_for_monetization: "Non sei ancora idoneo per la monetizzazione.",
  seven_days_challenges: "Sfide di 7 giorni",
  how_to_earn_more_utt_coins: "Come guadagnare più UTT Coins?",
  what_is_uut_coins: "Cosa sono gli UUT Coins?",
  how_to_earn_utt_coins: "Come guadagnare UTT Coins?",
  how_to_use_utt_coins: "Come usare gli UTT Coins?",
  complete: "Completo",
  give_10_comment: "Dai 10 commenti",
  upload_3_video_in_crime_category: "Carica 3 video nella categoria crimine",
  upload_3_pp: "Carica 3 PP (Power Play)",
  upload_3_audio: "Carica 3 Audio",

  refer_friend_earn: "Riferisci un amico e guadagna",
  copy_your_code: "Copia il tuo codice, condividilo con i tuoi amici.",
  your_refer_code: "Il tuo codice di referral",
  type_your_friends_refer_code: "Inserisci il codice di referral del tuo amico",
  redeem: "Riscatta",
  copy: "Copia",
  enter_code: "Inserisci codice",
  or_share: "Oppure condividi",
  how_it_work: "Come funziona?",
  invite_your_friend_by_using_this_code: "Invita il tuo amico utilizzando questo codice",
  they_use_this_code: "Loro usano questo codice.",
  you_get_500_utt_coins: "Ottieni 500 UTT Coins!",
  contact_number: "Numero di contatto",
  shirt_size: "Taglia della maglietta",
  district: "Distretto",
  thana: "Thana",
  delivery_address: "Indirizzo di consegna",
  full_address: "Indirizzo completo",
  prize_info_submitted_successfully: "Le informazioni sul premio sono state inviate con successo."
};